import React from "react";
import { Box } from "@chakra-ui/react";
import { SupplierPartForDelivery } from "./types";
import { SplitPartsList } from "./EstimateSplitCard/components/SplitPartsList";

interface DraftEstimatePartsCardProps {
  parts: SupplierPartForDelivery[];
}

/**
 * Read-only split of a DRAFT_ESTIMATE: part details only, full width. No
 * supplier, delivery options or configuration (a draft has none to act on).
 * Its status is shown in the estimate header.
 */
const DraftEstimatePartsCard: React.FC<DraftEstimatePartsCardProps> = ({
  parts,
}) => (
  <Box
    bg="gray.50"
    borderRadius="lg"
    border="1px solid"
    borderColor="orange.300"
    overflow="hidden"
    px={4}
    py={3}
  >
    <SplitPartsList parts={parts} maxH="none" />
  </Box>
);

export default DraftEstimatePartsCard;
